import { render, staticRenderFns } from "./base-form.vue?vue&type=template&id=0fb8af40"
import script from "./base-form.ts?vue&type=script&lang=ts&external"
export * from "./base-form.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports